<template>
  <div
    v-if="
      showSelvaggiaCannotRaise ||
      canSelvaggiaAct ||
      showSelvaggiaPassoHint ||
      showSelvaggiaWaiting
    "
    class="panoramica-actions"
  >
    <div v-if="showSelvaggiaCannotRaise" class="panoramica-selvaggia-hint">
      Non puoi alzare ulteriormente l'offerta
    </div>

    <template v-else-if="canSelvaggiaAct">
      <template v-if="migliore_offerta.offerta && !offertaToConfirm">
        <v-btn
          v-for="incremento in rilanciRelativi"
          :key="incremento"
          rounded
          color="primary"
          :disabled="!canRilanciareDi(incremento)"
          @click="preparaRilancio(incremento)"
        >
          +{{ incremento }}
        </v-btn>
      </template>

      <v-btn
        v-else-if="offertaToConfirm"
        rounded
        color="primary"
        class="pr-1"
        @click="confirmOfferta"
      >
        Confermo
        <crediti
          class="ml-2"
          :crediti="offertaToConfirm"
          variant="dark"
        ></crediti>
        <v-menu offset-y left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              x-small
              class="ml-1 white--text"
              v-bind="attrs"
              v-on="on"
              @click.stop
            >
              <v-icon small>expand_more</v-icon>
            </v-btn>
          </template>
          <v-list dense class="selvaggia-confirm-menu">
            <v-list-item @click="annullaOffertaToConfirm">
              <v-list-item-icon class="mr-2">
                <v-icon small color="navy">close</v-icon>
              </v-list-item-icon>
              <v-list-item-title class="navy--text text--darken-2 font-weight-bold pr-4">
                Annulla offerta
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-btn>

      <v-btn
        rounded
        color="primary"
        @click="showNumpad"
      >
        Offerta
      </v-btn>

      <v-btn
        rounded
        color="white"
        class="text--text"
        :disabled="vincitore === user_uid"
        @click="setPasso(true)"
      >
        Passo
      </v-btn>
    </template>

    <div v-else-if="showSelvaggiaPassoHint" class="panoramica-selvaggia-hint">
      {{ selvaggiaPassoText }}
    </div>

    <div v-else-if="showSelvaggiaWaiting" class="panoramica-selvaggia-hint">
      In attesa degli altri partecipanti...
    </div>
  </div>
</template>

<script>
import mixins from "../../js/mixins";
import astaSelvaggiaActionsMixin from "../../js/mixins/astaSelvaggiaActionsMixin";
import Crediti from "./Crediti";

export default {
  name: "asta-selvaggia-header-actions",
  mixins: [mixins, astaSelvaggiaActionsMixin],
  components: {
    Crediti,
  },
};
</script>

<style lang="scss" scoped>
.panoramica-actions {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
}

.selvaggia-confirm-menu {
  .v-list-item {
    min-height: 42px;
  }
}
</style>
